const request = require('request');
const config = require('./config');

var get = (token,filters) => {
  return new Promise((resolve,reject) => {
    request({
        headers: {
          'Content-Type': 'application/json',
          'User-Token': token
        },
        uri: config.URL_BACKEND+'/comunicado/'+filters.id,
        method: 'GET',
      }, (err, res, body) => {
        if (err) return reject(err);
        resolve({err: err, res: res, body: body});
    });
  });
};

var getTable = (token,filters) => {
  return new Promise((resolve,reject) => {
    request({
      headers: {
        'Content-Type': 'application/json',
        'User-Token': token
      },
      uri: config.URL_BACKEND+'/comunicadoTable',
      method: 'GET',
      qs: filters
    }, (err, res, body) => {
      if (err) return reject(err);
      resolve({err: err, res: res, body: body});
    });
  });
};

const any = (params,m_params) => {
  return new Promise((resolve,reject) => {
    const url = config.URL_BACKEND+m_params.uri;
    const response = fetch(url, {
      headers: {
        "User-Token": params.token
      },
      method: m_params.method,
      body: params.body
    });
    resolve(response);
  });
};

var deleta = (token,id) => {
  return new Promise((resolve,reject) => {
    request({
      headers: {
        'Content-Type': 'application/json',
        'User-Token': token
      },
      uri: config.URL_BACKEND+'/comunicado/'+id,
      method: 'DELETE',
    }, (err, res, body) => {
      if (err) return reject(err);
      resolve({err: err, res: res, body: body});
    });
  });
};

module.exports = {
  any:any,
  get:get,
  deleta:deleta,
  getTable:getTable
}